export enum ErrorTypes {
  UnhandledError = 'Unhandled Error',
  UserNotRegistered = 'User not registered',
  NoSitesAssigned = 'No sites assigned to user',
  ConnectionError = 'General connection error',
  HttpError = 'Http Error',
  LoginError = 'Login Error',
}
